(function () {
  var section = document.querySelector("[data-custom-pdp]");
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var productDataEl = section.querySelector("[data-product-json]");
  var inventoryDataEl = section.querySelector("[data-inventory-json]");
  if (!productDataEl || !inventoryDataEl) return;

  var product = JSON.parse(productDataEl.textContent);
  var inventory = JSON.parse(inventoryDataEl.textContent);
  var currentVariant = null;
  var selectedOptions = {};
  var mainSwiper = null;
  var thumbsSwiper = null;
  var selectedSellingPlan = "";
  var purchaseType = "onetime";
  var hasSellingPlans =
    product.selling_plan_groups && product.selling_plan_groups.length > 0;

  /* ========================================
     INIT
     ======================================== */

  function init() {
    setInitialVariant();
    initSwiper();
    initImageZoom();
    initVariantPickers();
    initSubscriptionWidget();
    initQuantity();
    initSeeMore();
    initTooltip();
    initAccordion();
    initAjaxAddToCart();
    updateEverything();
  }

  /* ========================================
     VARIANT LOGIC
     ======================================== */

  function setInitialVariant() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get("variant");
    if (variantId) {
      currentVariant = product.variants.find(function (v) {
        return v.id === parseInt(variantId, 10);
      });
    }
    if (!currentVariant) {
      currentVariant =
        product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
    }

    if (currentVariant && currentVariant.options) {
      product.options.forEach(function (optName, i) {
        selectedOptions[optName] = currentVariant.options[i];
      });
    }
  }

  function findVariantFromOptions() {
    return product.variants.find(function (variant) {
      return product.options.every(function (optName, i) {
        return String(variant.options[i]) === String(selectedOptions[optName]);
      });
    });
  }

  // Only earlier options constrain availability (Size stays selectable; Quantity filters by Size).
  function isOptionValueAvailable(optionName, optionValue) {
    var optionIndex = product.options.indexOf(optionName);
    if (optionIndex === -1) return true;

    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      if (String(variant.options[optionIndex]) !== String(optionValue)) return false;

      return product.options.every(function (optName, i) {
        if (i >= optionIndex) return true;
        return (
          !selectedOptions[optName] ||
          String(selectedOptions[optName]) === String(variant.options[i])
        );
      });
    });
  }

  // Prefer exact match; otherwise keep changed + earlier options and auto-pick later ones.
  function resolveVariantAfterOptionChange(changedOptionName) {
    var changedIndex = product.options.indexOf(changedOptionName);

    var exact = findVariantFromOptions();
    if (exact) return exact;

    var availableMatch = product.variants.find(function (variant) {
      if (!variant.available) return false;
      return product.options.every(function (optName, i) {
        if (i > changedIndex) return true;
        return String(variant.options[i]) === String(selectedOptions[optName]);
      });
    });
    if (availableMatch) return availableMatch;

    return product.variants.find(function (variant) {
      return product.options.every(function (optName, i) {
        if (i > changedIndex) return true;
        return String(variant.options[i]) === String(selectedOptions[optName]);
      });
    });
  }

  function syncSelectedOptionsFromVariant(variant) {
    if (!variant || !variant.options) return;
    product.options.forEach(function (optName, i) {
      selectedOptions[optName] = variant.options[i];
    });
  }

  function updateEverything() {
    updateVariantPills();
    updatePrice();
    updateFormInputs();
    updateAtcButton();
    updateUrl();
    updateSubscriptionPrices();
    updateMediaForVariant();
    validateQuantity();
  }

  function findSellingPlanById(planId) {
    if (!product.selling_plan_groups || !planId) return null;
    for (var i = 0; i < product.selling_plan_groups.length; i++) {
      var group = product.selling_plan_groups[i];
      if (group.selling_plans) {
        for (var j = 0; j < group.selling_plans.length; j++) {
          var plan = group.selling_plans[j];
          if (plan.id.toString() === planId.toString()) {
            return plan;
          }
        }
      }
    }
    return null;
  }

  function getFirstSellingPlan() {
    if (!product.selling_plan_groups || !product.selling_plan_groups.length)
      return null;
    var firstGroup = product.selling_plan_groups[0];
    if (firstGroup.selling_plans && firstGroup.selling_plans.length) {
      return firstGroup.selling_plans[0];
    }
    return null;
  }

  function calculateSubscriptionPrice(basePrice, plan) {
    if (!plan || !plan.price_adjustments || !plan.price_adjustments.length) {
      return basePrice;
    }
    var adj = plan.price_adjustments[0];
    if (adj.value_type === "percentage") {
      return Math.round((basePrice * (100 - adj.value)) / 100);
    } else if (adj.value_type === "fixed_amount") {
      return basePrice - adj.value;
    } else if (adj.value_type === "price") {
      return adj.value;
    }
    return basePrice;
  }

  function updatePrice() {
    var priceEl = section.querySelector("[data-pdp-price]");
    var comparePriceEl = section.querySelector("[data-pdp-compare-price]");
    if (!priceEl || !currentVariant) return;

    var price = currentVariant.price;
    var comparePrice = currentVariant.compare_at_price;

    if (purchaseType === "subscribe" && selectedSellingPlan) {
      var plan = findSellingPlanById(selectedSellingPlan);
      if (plan) {
        price = calculateSubscriptionPrice(price, plan);
      }
    }

    priceEl.textContent = formatMoney(price);
    if (comparePriceEl) {
      if (comparePrice && comparePrice > price) {
        comparePriceEl.textContent = formatMoney(comparePrice);
        comparePriceEl.style.display = "";
      } else {
        comparePriceEl.style.display = "none";
      }
    }
  }

  function updateFormInputs() {
    var variantSelect = section.querySelector("[data-pdp-variant-select]");
    var sellingPlanInput = section.querySelector("[data-pdp-selling-plan]");
    if (variantSelect && currentVariant) {
      variantSelect.value = currentVariant.id;
    }
    if (sellingPlanInput) {
      sellingPlanInput.value =
        purchaseType === "subscribe" ? selectedSellingPlan : "";
    }
  }

  function updateAtcButton() {
    var btn = section.querySelector("[data-add-to-cart]");
    var btnText = section.querySelector("[data-add-to-cart-text]");
    var atcPriceEl = section.querySelector("[data-atc-price]");
    if (!btn || !btnText) return;

    if (currentVariant && currentVariant.available) {
      btn.disabled = false;
      var price = currentVariant.price;
      if (purchaseType === "subscribe" && selectedSellingPlan) {
        var plan = findSellingPlanById(selectedSellingPlan);
        if (plan) {
          price = calculateSubscriptionPrice(price, plan);
        }
      }

      if (atcPriceEl) {
        atcPriceEl.textContent = formatMoney(price);
      } else {
        var defaultText = btnText.dataset.defaultText || "Add to Cart";
        btnText.innerHTML =
          defaultText +
          " &ndash; <span data-atc-price>" +
          formatMoney(price) +
          "</span>";
      }
    } else {
      btn.disabled = true;
      btnText.textContent = "Sold Out";
    }
  }

  function updateUrl() {
    if (!currentVariant) return;
    var url = new URL(window.location.href);
    url.searchParams.set("variant", currentVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  function updateMediaForVariant() {
    if (!currentVariant || !currentVariant.featured_media || !mainSwiper)
      return;
    var mediaId = currentVariant.featured_media.id;
    var slides = section.querySelectorAll(
      ".custom-pdp__main-image .swiper-slide",
    );
    slides.forEach(function (slide, index) {
      if (parseInt(slide.dataset.mediaId, 10) === mediaId) {
        mainSwiper.slideTo(index);
      }
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return "$" + amount;
  }

  /* ========================================
     SWIPER
     ======================================== */

  function initSwiper() {
    var mainEl = section.querySelector(".custom-pdp__gallery-swiper");
    if (!mainEl || typeof Swiper === "undefined") return;

    var isMobile = window.innerWidth <= 768;

    mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 36,
      loop: false,
      pagination: isMobile
        ? {
            el: section.querySelector(".custom-pdp__gallery-pagination"),
            clickable: true,
          }
        : false,
      on: {
        slideChange: function () {
          updateThumbActive(this.activeIndex);
        },
      },
    });

    var thumbEls = section.querySelectorAll(".custom-pdp__thumb");
    thumbEls.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        if (mainSwiper) {
          mainSwiper.slideTo(index);
        }
      });
    });

    updateThumbActive(0);
  }

  function updateThumbActive(activeIndex) {
    var thumbs = section.querySelectorAll(".custom-pdp__thumb");
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle("is-active", i === activeIndex);
    });
  }

  /* ========================================
     MEDIA LIGHTBOX (PhotoSwipe — images + videos)
     ======================================== */

  function escapeAttr(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }

  function getSlideDimensions(slide, fallbackEl) {
    var width = parseInt(slide.dataset.mediaWidth, 10);
    var height = parseInt(slide.dataset.mediaHeight, 10);

    if (width && height) {
      return { w: width, h: height };
    }

    if (fallbackEl) {
      var rect = fallbackEl.getBoundingClientRect();
      if (rect.width && rect.height) {
        return {
          w: Math.round(rect.width),
          h: Math.round(rect.height),
        };
      }
    }

    return { w: 1280, h: 720 };
  }

  function getVideoSources(video) {
    var sources = Array.from(video.querySelectorAll("source")).map(
      function (source) {
        return {
          src: source.src,
          type: source.type || "video/mp4",
        };
      },
    );

    if (!sources.length && video.src) {
      sources.push({
        src: video.src,
        type: video.getAttribute("type") || "video/mp4",
      });
    }

    return sources;
  }

  function buildVideoHtml(sources, poster) {
    var sourceTags = sources
      .map(function (source) {
        return (
          '<source src="' +
          escapeAttr(source.src) +
          '" type="' +
          escapeAttr(source.type) +
          '">'
        );
      })
      .join("");

    return (
      '<div class="custom-pdp__pswp-video">' +
      '<video class="custom-pdp__pswp-video-el" controls playsinline loop' +
      (poster ? ' poster="' + escapeAttr(poster) + '"' : "") +
      ">" +
      sourceTags +
      "</video></div>"
    );
  }

  function buildMediaItems(galleryEl) {
    var items = [];

    galleryEl.querySelectorAll(".swiper-slide").forEach(function (slide) {
      var img = slide.querySelector(".photoswipe__image");
      var video = slide.querySelector("video");
      var iframe = slide.querySelector("iframe");
      var dimensions = getSlideDimensions(
        slide,
        img || video || iframe || slide,
      );

      if (img) {
        items.push({
          msrc: img.currentSrc || img.src,
          src: img.getAttribute("data-photoswipe-src"),
          w:
            parseInt(img.getAttribute("data-photoswipe-width"), 10) ||
            dimensions.w,
          h:
            parseInt(img.getAttribute("data-photoswipe-height"), 10) ||
            dimensions.h,
          el: img,
          type: "image",
          initialZoomLevel: 0.5,
        });
        return;
      }

      if (video) {
        items.push({
          html: buildVideoHtml(
            getVideoSources(video),
            video.getAttribute("poster"),
          ),
          w: dimensions.w,
          h: dimensions.h,
          el: video,
          type: "video",
        });
        return;
      }

      if (iframe) {
        items.push({
          html: '<div class="custom-pdp__pswp-iframe-wrap"></div>',
          w: dimensions.w,
          h: dimensions.h,
          el: iframe,
          type: "external_video",
          iframeSrc: iframe.src,
        });
      }
    });

    return items;
  }

  function pauseAllLightboxMedia(root) {
    if (!root) return;

    root.querySelectorAll("video").forEach(function (video) {
      video.pause();
    });

    root
      .querySelectorAll(".custom-pdp__pswp-iframe-wrap iframe")
      .forEach(function (iframe) {
        iframe.remove();
      });
  }

  function playActiveLightboxMedia(gallery) {
    if (!gallery || !gallery.currItem) return;

    var container = gallery.currItem.container;
    if (!container) return;

    if (gallery.currItem.type === "external_video") {
      var wrap = container.querySelector(".custom-pdp__pswp-iframe-wrap");
      if (wrap && !wrap.querySelector("iframe") && gallery.currItem.iframeSrc) {
        var iframe = document.createElement("iframe");
        iframe.src = gallery.currItem.iframeSrc;
        iframe.setAttribute("allow", "autoplay; fullscreen; encrypted-media");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("frameborder", "0");
        wrap.appendChild(iframe);
      }
      return;
    }

    var video = container.querySelector(".custom-pdp__pswp-video-el");
    if (video) {
      video.play().catch(function () {});
    }
  }

  function openMediaLightbox(galleryEl, openIndex) {
    if (
      typeof PhotoSwipe === "undefined" ||
      typeof PhotoSwipeUI_Default === "undefined"
    ) {
      return;
    }

    var items = buildMediaItems(galleryEl);
    if (!items.length) return;

    var pswpElement = document.querySelector(".pswp");
    if (!pswpElement) return;

    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
      allowPanToNext: false,
      arrowEl: items.length > 1,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: openIndex,
      pinchToClose: false,
      preloaderEl: false,
      scaleMode: "fit",
      shareEl: false,
      tapToToggleControls: false,
      getThumbBoundsFn: function (index) {
        var pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        var el = items[index] && items[index].el;
        if (!el) {
          return { x: 0, y: 0, w: 0 };
        }

        var rect = el.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width,
        };
      },
    });

    gallery.listen("afterChange", function () {
      pauseAllLightboxMedia(pswpElement);
      playActiveLightboxMedia(gallery);
    });

    gallery.listen("close", function () {
      pauseAllLightboxMedia(pswpElement);
    });

    gallery.listen("initialZoomInEnd", function () {
      playActiveLightboxMedia(gallery);
    });

    gallery.init();
  }

  function bindGalleryLightbox(galleryEl) {
    if (!galleryEl || galleryEl.dataset.pswpBound === "1") return;
    if (!galleryEl.querySelector(".swiper-slide")) return;

    galleryEl.dataset.pswpBound = "1";

    galleryEl
      .querySelectorAll(".swiper-slide")
      .forEach(function (slide, index) {
        var img = slide.querySelector(".photoswipe__image");
        var trigger = slide.querySelector("[data-media-trigger]");

        if (img) {
          img.addEventListener("click", function () {
            openMediaLightbox(galleryEl, index);
          });
        }

        if (trigger) {
          if (
            trigger.classList.contains("custom-pdp__media-trigger--external")
          ) {
            trigger.addEventListener("click", function (e) {
              e.preventDefault();
              openMediaLightbox(galleryEl, index);
            });
          }

          var openBtn = trigger.querySelector(".custom-pdp__media-open");
          if (openBtn) {
            openBtn.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
              var inlineVideo = trigger.querySelector("video");
              if (inlineVideo) {
                inlineVideo.pause();
              }
              openMediaLightbox(galleryEl, index);
            });
          }
        }
      });
  }

  function initImageZoom() {
    bindGalleryLightbox(section.querySelector(".custom-pdp__gallery-swiper"));
    bindGalleryLightbox(section.querySelector(".product-mobile__images"));
  }

  /* ========================================
     VARIANT PICKERS
     ======================================== */

  function initVariantPickers() {
    var pills = section.querySelectorAll("[data-option-value]");
    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        if (pill.classList.contains("is-unavailable") || pill.disabled) return;

        var optionName = pill.dataset.optionName;
        var optionValue = pill.dataset.optionValue;
        selectedOptions[optionName] = optionValue;

        var variant = resolveVariantAfterOptionChange(optionName);
        if (variant) {
          currentVariant = variant;
          syncSelectedOptionsFromVariant(variant);
        }
        updateEverything();
      });
    });
  }

  function updateVariantPills() {
    var pills = section.querySelectorAll("[data-option-value]");
    pills.forEach(function (pill) {
      var optName = pill.dataset.optionName;
      var optValue = pill.dataset.optionValue;
      var isActive = String(selectedOptions[optName]) === String(optValue);
      var isAvailable = isOptionValueAvailable(optName, optValue);

      pill.classList.toggle("is-active", isActive);
      pill.classList.toggle("is-unavailable", !isAvailable);
      pill.setAttribute("aria-disabled", isAvailable ? "false" : "true");
      pill.disabled = !isAvailable;
    });
  }

  /* ========================================
     SUBSCRIPTION WIDGET
     ======================================== */

  function initSubscriptionWidget() {
    var subscribeRadio = section.querySelector("[data-subscribe-radio]");
    var onetimeRadio = section.querySelector("[data-onetime-radio]");
    var frequencySelect = section.querySelector("[data-frequency-select]");
    var subscribeBox = section.querySelector("[data-subscribe-box]");
    var onetimeBox = section.querySelector("[data-onetime-box]");

    if (!subscribeRadio && !onetimeRadio) return;

    if (frequencySelect && frequencySelect.value) {
      selectedSellingPlan = frequencySelect.value;
    }

    function selectSubscribe() {
      purchaseType = "subscribe";
      if (subscribeRadio) subscribeRadio.classList.add("is-selected");
      if (onetimeRadio) onetimeRadio.classList.remove("is-selected");
      if (subscribeBox) subscribeBox.classList.add("is-active");
      if (onetimeBox) onetimeBox.classList.remove("is-active");
      if (frequencySelect && frequencySelect.value) {
        selectedSellingPlan = frequencySelect.value;
      }
      updatePrice();
      updateFormInputs();
      updateSubscriptionPrices();
      updateAtcButton();
    }

    function selectOnetime() {
      purchaseType = "onetime";
      selectedSellingPlan = "";
      if (subscribeRadio) subscribeRadio.classList.remove("is-selected");
      if (onetimeRadio) onetimeRadio.classList.add("is-selected");
      if (subscribeBox) subscribeBox.classList.remove("is-active");
      if (onetimeBox) onetimeBox.classList.add("is-active");
      updatePrice();
      updateFormInputs();
      updateSubscriptionPrices();
      updateAtcButton();
    }

    if (subscribeBox) {
      subscribeBox.addEventListener("click", function () {
        selectSubscribe();
      });
    }

    if (onetimeBox) {
      onetimeBox.addEventListener("click", selectOnetime);
    }

    if (frequencySelect) {
      frequencySelect.addEventListener("focus", selectSubscribe);
      frequencySelect.addEventListener("change", function () {
        selectedSellingPlan = this.value;
        selectSubscribe();
      });
    }

    // Default to One Time Purchase
    selectOnetime();
  }

  function updateSubscriptionPrices() {
    if (!currentVariant) return;

    var subscribePriceEl = section.querySelector("[data-subscribe-price]");
    var onetimePriceEl = section.querySelector("[data-onetime-price]");

    if (onetimePriceEl) {
      onetimePriceEl.textContent = formatMoney(currentVariant.price);
    }

    if (subscribePriceEl) {
      var plan = selectedSellingPlan
        ? findSellingPlanById(selectedSellingPlan)
        : getFirstSellingPlan();

      if (plan) {
        var discountedPrice = calculateSubscriptionPrice(
          currentVariant.price,
          plan,
        );
        subscribePriceEl.textContent = formatMoney(discountedPrice);
      } else {
        subscribePriceEl.textContent = formatMoney(currentVariant.price);
      }
    }
  }

  /* ========================================
     QUANTITY
     ======================================== */

  function getMaxQuantity() {
    if (!currentVariant) return 150;
    var inv = inventory[currentVariant.id];
    var max = 150;
    if (
      inv &&
      inv.inventory_management &&
      inv.inventory_policy !== "continue"
    ) {
      max = Math.min(150, inv.inventory_quantity);
    }
    return max > 0 ? max : 1; // Ensure at least 1 if available
  }

  function updateQuantityButtonsState() {
    var minusBtn = section.querySelector("[data-qty-minus]");
    var plusBtn = section.querySelector("[data-qty-plus]");
    var input = section.querySelector("[data-qty-input]");
    if (!minusBtn || !plusBtn || !input) return;

    var val = parseInt(input.value, 10) || 1;
    var max = getMaxQuantity();

    minusBtn.disabled = val <= 1;
    plusBtn.disabled = val >= max;
  }

  function validateQuantity() {
    var input = section.querySelector("[data-qty-input]");
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var max = getMaxQuantity();

    if (val > max) {
      input.value = max;
    } else if (val < 1) {
      input.value = 1;
    }
    updateQuantityButtonsState();
  }

  function initQuantity() {
    var minusBtn = section.querySelector("[data-qty-minus]");
    var plusBtn = section.querySelector("[data-qty-plus]");
    var input = section.querySelector("[data-qty-input]");
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener("click", function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) {
        input.value = val - 1;
        validateQuantity();
      }
    });

    plusBtn.addEventListener("click", function () {
      var val = parseInt(input.value, 10) || 1;
      var max = getMaxQuantity();
      if (val < max) {
        input.value = val + 1;
        validateQuantity();
      }
    });

    input.addEventListener("change", function () {
      validateQuantity();
    });

    validateQuantity(); // Initial check
  }

  /* ========================================
     SEE MORE
     ======================================== */

  function initSeeMore() {
    var btn = section.querySelector("[data-see-more]");
    var fullDesc = section.querySelector("[data-desc-full]");
    var shortDesc = section.querySelector("[data-desc-short]");
    if (!btn || !fullDesc || !shortDesc) return;

    btn.addEventListener("click", function () {
      var isExpanded = fullDesc.classList.toggle("is-visible");
      shortDesc.classList.toggle("is-hidden", isExpanded);
      btn.textContent = isExpanded ? "See less" : "See more";
    });
  }

  /* ========================================
     TOOLTIP
     ======================================== */

  function initTooltip() {
    var trigger = section.querySelector("[data-tooltip-trigger]");
    var tooltip = section.querySelector("[data-tooltip]");
    if (!trigger || !tooltip) return;

    trigger.addEventListener("click", function (e) {
      // If clicking inside the tooltip, don't toggle (prevents closing when clicking contents)
      if (tooltip.contains(e.target)) {
        e.stopPropagation();
        return;
      }

      e.stopPropagation();
      tooltip.classList.toggle("is-visible");
    });

    document.addEventListener("click", function (e) {
      if (!tooltip.contains(e.target) && !trigger.contains(e.target)) {
        tooltip.classList.remove("is-visible");
      }
    });
  }

  /* ========================================
     ACCORDION
     ======================================== */

  function initAccordion() {
    var items = section.querySelectorAll(".custom-pdp__accordion-item");

    items.forEach(function (item) {
      var summary = item.querySelector("summary");
      var content = item.querySelector(".custom-pdp__accordion-content");
      if (!summary || !content) return;

      // Prevent the native details toggle — we drive it manually
      summary.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = item.classList.contains("is-open");

        if (isOpen) {
          // Close this item
          item.classList.remove("is-open");
          // After transition ends, remove the [open] attr so it's fully collapsed
          content.addEventListener("transitionend", function handler() {
            if (!item.classList.contains("is-open")) {
              item.removeAttribute("open");
            }
            content.removeEventListener("transitionend", handler);
          });
        } else {
          // Close all others first
          items.forEach(function (other) {
            if (other !== item && other.classList.contains("is-open")) {
              other.classList.remove("is-open");
              other
                .querySelector(".custom-pdp__accordion-content")
                .addEventListener("transitionend", function handler() {
                  if (!other.classList.contains("is-open")) {
                    other.removeAttribute("open");
                  }
                  other
                    .querySelector(".custom-pdp__accordion-content")
                    .removeEventListener("transitionend", handler);
                });
            }
          });

          // Open this item: set [open] first so content is in the DOM, then add class
          item.setAttribute("open", "");
          // Force reflow so transition fires
          void content.offsetHeight;
          item.classList.add("is-open");
        }
      });

      // Sync initial state: if details has [open], add is-open
      if (item.hasAttribute("open")) {
        item.classList.add("is-open");
      }
    });
  }

  /* ========================================
     AJAX ADD TO CART
     ======================================== */

  function initAjaxAddToCart() {
    var form = section.querySelector("[data-product-form]");
    if (!form || form.dataset.pcfAtcBound === "1") return;
    form.dataset.pcfAtcBound = "1";

    var isAdding = false;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (isAdding) return;

      var btn = section.querySelector("[data-add-to-cart]");
      var btnText = section.querySelector("[data-add-to-cart-text]");
      if (!btn || !currentVariant || !currentVariant.available) return;

      isAdding = true;
      btn.disabled = true;
      var originalText = btnText.textContent;
      btnText.textContent = "Adding...";

      var qtyInput = section.querySelector("[data-qty-input]");
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var cartPayload = {
        id: currentVariant.id,
        quantity: quantity,
      };

      if (purchaseType === "subscribe" && selectedSellingPlan) {
        cartPayload.selling_plan = selectedSellingPlan;
      }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(cartPayload),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 422 || data.message) {
            btnText.textContent = data.message || "Error";
            setTimeout(function () {
              btnText.textContent = originalText;
              btn.disabled = false;
              isAdding = false;
            }, 2000);
            return;
          }

          btnText.textContent = "Added!";

          if (typeof window.openCartDrawer === "function") {
            window.openCartDrawer(true);
          }

          fetch(window.Shopify.routes.root + "cart.js")
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent("cart:refresh", { detail: { cart: cart } }),
              );
              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: { cart: cart },
                }),
              );
            })
            .catch(function () {
              document.dispatchEvent(
                new CustomEvent("cart:updated", { detail: {} }),
              );
            });

          setTimeout(function () {
            btnText.textContent = originalText;
            btn.disabled = false;
            isAdding = false;
          }, 1500);
        })
        .catch(function (error) {
          console.error("Add to cart error:", error);
          btnText.textContent = "Error";
          setTimeout(function () {
            btnText.textContent = originalText;
            btn.disabled = false;
            isAdding = false;
          }, 2000);
        });
    });
  }

  /* ========================================
     BOOT
     ======================================== */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.detail.sectionId === sectionId) {
      var galleries = section.querySelectorAll(
        ".custom-pdp__gallery-swiper, .product-mobile__images",
      );
      galleries.forEach(function (galleryEl) {
        delete galleryEl.dataset.pswpBound;
      });
      init();
      initMobileSwiper();
    }
  });
})();

/* ========================================
   MOBILE SWIPER (≤900px)
   ======================================== */

document.addEventListener("DOMContentLoaded", function () {
  initMobileSwiper();
});

function initMobileSwiper() {
  var swiperElement = document.querySelector(".product-mobile__images");
  if (swiperElement && typeof Swiper !== "undefined") {
    new Swiper(".product-mobile__images", {
      slidesPerView: 1.8,
      spaceBetween: 18,
      zoom: true,
      slidesOffsetBefore: 18,
      slidesOffsetAfter: 18,
      pagination: {
        el: ".product-mobile__images .swiper-pagination",
        clickable: true,
      },
    });
  }
}
